import {Col, Container, Row} from "react-bootstrap";
import {useContext, useEffect, useState} from "react";
import AppContext from "../contexts/app-context";
import * as backendUtils from "../helper/BackendUtils";
import FeedCard from "../components/FeedCard";
import './CommunityFeed.css';

function CommunityFeed() {
    const context = useContext(AppContext);
    const [topRider, setTopRider] = useState([]);
    const [feed, setFeed] = useState([]);

    const getFeed = () => {
        if (context.backendUri) {
            backendUtils.getRequest(`${context.backendUri}/stats/feed`, {}, response => {
                const feed = response.data.filter((ride) => ride.distance > 0).map((ride) => {
                    return {
                        "activityName": ride.activityName,
                        "email": ride.email,
                        "distance": parseFloat(ride.distance / 1000).toFixed(1) / 1.0
                    }
                })
                setFeed(feed);
            }, err => {
                console.log(backendUtils.getErrorMessage(err));
            }).catch((err) => console.log(err))
        }
    }

    const getKingOfDay = () => {
        if (context.backendUri) {
            backendUtils.getRequest(`${context.backendUri}/stats/kingOfDay`, {}, response => {
                const kings = response.data.filter((ride) => ride.distance > 0).map((ride) => {
                    return {
                        "activityName": ride.activityName,
                        "email": ride.email,
                        "distance": parseFloat(ride.distance / 1000).toFixed(1) / 1.0
                    }
                })
                setTopRider(kings);
            }, err => {
                console.log(backendUtils.getErrorMessage(err));
            }).catch((err) => console.log(err))
        }
    }

    useEffect(() => {
        getFeed();
        getKingOfDay();
    }, [context.backendUri])

    return (
        <Container className="text-center">
            <h1>Todays efforts ({new Date().toLocaleDateString()})</h1>
            <hr/>
            <h2>Currently longest ride trophy belongs to: </h2>
            <Row>
                {
                    topRider?.map((rider, index) => {
                        return (
                            <Col className="pretty-column">
                                <FeedCard
                                    key={index}
                                    email={rider.email}
                                    activityName={rider.activityName}
                                    distance={rider.distance}
                                    isKing={true}
                                />
                            </Col>
                        )
                    })
                }
            </Row>
            <h2 className="m-2">All rides:</h2>
            <Row className="row-columns-margins-shadow">
                {
                    feed?.sort((a, b) => b.distance - a.distance).map((ride, index) => {
                        return (
                            <Col className="m-2">
                                <FeedCard
                                    key={index}
                                    activityName={ride.activityName}
                                    email={ride.email}
                                    distance={ride.distance}
                                    isKing={false}
                                />
                            </Col>
                        )
                    })
                }
            </Row>
        </Container>)
}

export default CommunityFeed;